import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import * as XLSX from 'xlsx';
import { firstValueFrom } from 'rxjs';
import { PopupService } from './popup.service'; // Adjust path
import { ExcelViewerComponent } from '../custom-modules/excel-viewer.component'; // Adjust path
import { WebService } from './web.service'; // Your existing getWebCall wrapper

@Injectable({ providedIn: 'root' })
export class ExcelViewerService {
  constructor(
    private popup: PopupService,
    private webService: WebService
  ) { }

  async previewExcel(path: string, filename: string) {
    const params = [
      { name: 'path', value: path },
      { name: 'filename', value: filename }
    ];

    try {
      const blob = await firstValueFrom(this.webService.getWebCall('files', 'download', {
        params,
        responseType: 'blob'
      }));

      const arrayBuffer = await blob.arrayBuffer();
      const workbook = XLSX.read(arrayBuffer, { type: 'array' });

      const sheets = workbook.SheetNames.map(name => ({
        name,
        rows: XLSX.utils.sheet_to_json(workbook.Sheets[name], { header: 1 }) // array of arrays
      }));
      this.popup.open({
        title: filename,
        component: ExcelViewerComponent,
        data: { sheets }
      });
    } catch (err) {
      console.error('Failed to preview Excel file:', err);
    }
  }
}
